import React, { Component } from 'react';

import { arrayOf, bool, element, func, shape } from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withState } from 'recompose';
import { bindActionCreators } from 'redux';

import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons/faCircleQuestion';

import MenuItem from '@mui/material/MenuItem';

import Button from 'components/Common/Buttons/ButtonV3';
import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';
import SupportLink from 'components/Common/SupportLink';
import { SUPPORT_URL } from 'config_app';
import withRouter from 'containers/withRouter';

import withUserType from 'containers/withUserType';
import withMediaInfo from 'HOC/withMediaInfo';
import { isNonEmptyArray } from 'utils/arrays';

import * as actions from 'modules/WelcomeWidget/actions';

import WelcomeWidgetModal from 'modules/WelcomeWidget/components/WelcomeWidgetModal';
import WithPopover from 'modules/WelcomeWidget/components/WithPopover';

// TODO: Fix unused classes which appeared after fixing import syntax
// eslint-disable-next-line css-modules/no-unused-class
import s from './WelcomeWidget.css';

@withRouter
@withMediaInfo()
@withState('anchor', 'setAnchor', null)
@withState('modalOpen', 'setModalOpen', false)
@withUserType
@connect(
  ({ welcomeWidget, user: { featureOnboarding } }) => ({
    ...welcomeWidget,
    featureOnboarding,
  }),
  dispatch => bindActionCreators({ ...actions }, dispatch),
)
@withTranslation()
export default class WelcomeWidget extends Component {
  async componentDidMount() {
    const { fetched, getWelcomeWidget } = this.props;
    if (!fetched) {
      await getWelcomeWidget();
    }
  }

  componentDidUpdate() {
    const {
      content,
      viewed,
      showOnLogin,
      markWelcomeWidgetViewed,
      modalOpen,
      setModalOpen,
    } = this.props;
    if (content && !viewed && !modalOpen && showOnLogin) {
      // user didn't view it, and the message is marked as show on login
      // then show up automatically

      setModalOpen(true);
      markWelcomeWidgetViewed();
    }
  }

  getStartedOnClick = () => {
    const { setAnchor, setModalOpen } = this.props;
    setModalOpen(true);
    setAnchor(null);
  };

  renderWelcomeWidgetContents = () => {
    const { user, t } = this.props;
    return (
      <>
        {(user.isCounselor || user.isGuardian || user.isMember) && (
          <MenuItem onClick={this.getStartedOnClick}>
            {t('WelcomeWidget.GettingStarted')}
          </MenuItem>
        )}
        {(user.isCounselor || user.isStudent || user.isGuardian) && (
          <MenuItem>
            <SupportLink
              className={s.supportLink}
              variant="hyperlink"
              hyperlinkColor="black"
              text={t('WelcomeWidget.HelpCenter')}
              url={SUPPORT_URL}
            />
          </MenuItem>
        )}
        {user.isCounselor && (
          <>
            <MenuItem
              onClick={() =>
                window.open('https://go.schoolinks.com/summer-trainings')
              }
            >
              {t('WelcomeWidget.WebinarTraining')}
            </MenuItem>
            <MenuItem
              onClick={() => window.open('https://vip.schoolinks.com/')}
            >
              SchooLinks {t('WelcomeWidget.AllAccess')}
            </MenuItem>
          </>
        )}
      </>
    );
  };

  render() {
    const { content, anchor, setAnchor, modalOpen, setModalOpen, mediaInfo } =
      this.props;

    const { isMobile } = mediaInfo;

    return (
      <>
        {isNonEmptyArray(content) && (
          <WelcomeWidgetModal
            open={modalOpen}
            onClose={setModalOpen}
            content={content}
          />
        )}
        {isMobile ? (
          this.renderWelcomeWidgetContents()
        ) : (
          <WithPopover
            hideArrow
            anchor={anchor}
            setAnchor={setAnchor}
            popover={this.renderWelcomeWidgetContents()}
          >
            <Button
              className={s.helpIcon}
              compactVariant="default"
              icon={<FontAwesomeIcon icon={faCircleQuestion} color="white" />}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                setAnchor(e.currentTarget);
              }}
            />
          </WithPopover>
        )}
      </>
    );
  }
}

WelcomeWidget.propTypes = {
  user: shape({}),
  anchor: element,
  modalOpen: bool,
  setAnchor: func.isRequired,
  setModalOpen: func.isRequired,
  content: arrayOf(element),
  fetched: bool.isRequired,
  getWelcomeWidget: func.isRequired,
  viewed: bool.isRequired,
  showOnLogin: bool.isRequired,
  markWelcomeWidgetViewed: func.isRequired,
  mediaInfo: shape({
    isMobile: bool.isRequired,
  }).isRequired,
  t: func.isRequired,
};

WelcomeWidget.defaultProps = {
  user: null,
  anchor: null,
  modalOpen: false,
  content: [],
};
